import { LoaderFunction, useFetcher } from "react-router-dom";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";
import {
  addToCart,
  Cart,
} from "../../../../common/api/decimal/methods/cart.ts";

interface StoreMultiCartData {
  variants: { id: number; quantity?: number }[];
}

// adds multiple items to the virtual store cart

export const storeMultiCartAction: LoaderFunction = async ({
  request,
}): Promise<PromiseSettledResult<DecimalResult<Cart>>[]> => {
  const data = (await request.json()) as StoreMultiCartData;
  const method = request.method;

  const variants = data.variants;

  if (method === "POST" && variants.length) {
    return await Promise.allSettled(
      variants.map(({ id, quantity = 1 }) => addToCart(id, quantity))
    );
  }

  return Promise.resolve([]);
};

export function useStoreMultiCartFetcher() {
  return useFetcher<Promise<PromiseSettledResult<DecimalResult<Cart>>[]>>();
}
